import SignUpPage from './SignUpPage';
export default SignUpPage;


// WEBPACK FOOTER //
// ./src/modules/onboarding/pages/signup/index.js